import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { ChoferApiService } from 'src/app/service/api/tablas-maestras-api.service';
import { BaseForm } from 'src/app/view/base-form';
import { ChoferModel } from 'src/app/models/ventas/tablas-maestras.model';
import { ChoferFormDefinition } from './form-control/form-definition';

@Component({
  selector: 'app-formulario-pulverizacion',
  standalone: false,
  templateUrl: './chofer-form.component.html',
  styleUrls: ['./chofer-form.component.scss'],
})
export class ChoferFormComponent extends BaseForm<ChoferModel> implements OnInit {
  public form!: ChoferFormDefinition;
  public override model: ChoferModel = {};

  public getRequest!: RequestHandler<ChoferModel[]>;

  constructor(
    public override route: ActivatedRoute,
    public override dashboard: DashboardService,
    public override router: Router,
    public choferApi: ChoferApiService,
  ) {
    super(
      route,
      router,
      dashboard,
      choferApi.choferPUT,
      choferApi.choferPOST,
      'chofer',
      'Actualizar Chofer',
      'Generar Chofer',
      'Duplicar Chofer',
    );

    this.getRequest = this.choferApi.choferGET;
  }

  public ngOnInit(): void {
    this.softInit(this.getType());
    this.form = new ChoferFormDefinition(this.getType(), this.model);
  }
}
